import axios from 'axios';
import { refreshAccessToken } from './authService';

const axiosInstance = axios.create({
  baseURL: 'https://trueface.co.in/',
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('bgc_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    const userEmail = localStorage.getItem('user_email');
    if (userEmail) {
      config.headers['X-User'] = userEmail;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('bgc_refresh_token');
      if (refreshToken) {
        try {
          const { accessToken } = await refreshAccessToken(refreshToken);
          localStorage.setItem('bgc_token', accessToken);
          originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
          return axiosInstance(originalRequest); 
        } catch (refreshError) {
          console.error('Refresh token failed:', refreshError);
          localStorage.removeItem('bgc_token');
          localStorage.removeItem('bgc_refresh_token');
          window.location.href = '/';
        }
      } else {
        localStorage.removeItem('bgc_token');
        localStorage.removeItem('bgc_refresh_token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;